var React = require('react');

function YoutubeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1443.556 98.702c-40.96-71.964-85.333-85.049-175.787-90.169-90.169-5.973-317.156-8.533-513.707-8.533-197.12 0-424.107 2.56-514.276 8.533-90.169 5.12-134.827 18.204-176.071 90.169-42.098 71.68-63.716 195.413-63.716 413.013v0.853c0 216.747 21.618 341.049 63.716 412.16 41.244 71.964 85.618 85.049 175.787 91.022 90.453 5.12 317.44 8.249 514.56 8.249 196.551 0 423.538-3.129 513.991-8.249 90.169-5.973 134.542-19.058 175.502-91.022 42.382-70.827 64-195.413 64-412.16v-0.853c0-217.6-21.618-341.333-64-413.013zM565.476 791.324v-558.649l471.040 279.324z"}));
}

YoutubeIcon.defaultProps = {"viewBox":"0 0 1508 1024","id":"icon-youtube"};

module.exports = YoutubeIcon;

YoutubeIcon.default = YoutubeIcon;
